import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Clark extends Lit3formBlock {
  static get characterName() {
    return 'clark';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid clark-layout">
          ${this.headerHTML}
          <div class="images">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    if (!image.text) {
      return html`
        <div class="image-wrapper">
          <div class="image">
            <img src=${this.imageUrl(image)} />
          </div>
        </div>
      `;
    }
    return html`
      <driver-card
        class="image-wrapper"
        .card=${image}
        placement=${this.analyticsBlockLabel}
        download-placement=${this.headerText}
        image-width="300"
      >
        ${this.textSectionsHTML(image)}
        <cta-text
          cta-data=${this.imageCtaData(image)}
          .ctaAnalyticsData=${analyticsCtaDataObject(image, this.headerText)}
        ></cta-text>
      </driver-card>
    `;
  }

  textSectionsHTML(image) {
    return image.text_sections?.length > 0
      ? html`
          <div class="text-sections-wrapper">
            ${image.text_sections.map(section => {
              return html`
                <span class="text-section">
                  <p>
                    <b>${unsafeHTML(this.withLineBreaks(section.heading))}</b>
                    ${section.paragraphs.map(paragraph => {
                      return unsafeHTML(this.withLineBreaks(paragraph));
                    })}
                  </p>
                </span>
              `;
            })}
          </div>
        `
      : html``;
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, 300);
  }

  imageCtaData(image) {
    let cta = {};
    if (image) {
      cta.text = image.text;
      cta.url = image.url;
    }
    return JSON.stringify(cta);
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <div class="header details-row">
            <h2>${unsafeHTML(this.headerText)}</h2>
            ${this.descriptionHTML}
          </div>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description details-row">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }
}
Clark.defineElement();
